__turbopack_context__.v({
  "callout": "j2UUDa_callout",
  "callout__body": "j2UUDa_callout__body",
  "callout__title": "j2UUDa_callout__title",
});
